import {
  Component,
  OnInit,
  Input,
  ViewChild
} from '@angular/core';
import {
  BilanEco,
  UserApi,
  BilanEcoLine
} from 'src/app/models/api_models/user';
import {
  UserApiService
} from 'src/app/user-api.service';
import {
  BookService
} from 'src/app/api/book.service';
import {
  MatTableDataSource
} from '@angular/material/table';
import {
  MatPaginator,
} from '@angular/material/paginator';
import {
  MatSort
} from '@angular/material/sort';

@Component({
  selector: 'app-eco-bilan-resume',
  templateUrl: './eco-bilan-resume.component.html',
  styleUrls: ['./eco-bilan-resume.component.scss']
})
export class EcoBilanResumeComponent implements OnInit {


  DisplayMonth : string[] = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"];

  displayedColumns: string[] = ['startdate', "duration", "km", 'bilan'];
  currentBilanDataSource: MatTableDataSource < BilanEcoLine >  = new MatTableDataSource();
  currentBilanWantedDataSource: MatTableDataSource < BilanEcoLine >  = new MatTableDataSource();


  public loadCurrenMonth: boolean = false;
  public loadCurrentMonthDetail: boolean = false;
  public selectedMonthLoad: boolean = false;
  public allLoad: boolean = false;
  private _currentMonth: BilanEco = null
  public completeEco: BilanEco = null;
  public wantedBilan : BilanEcoLine[] = null;
  public monthWanted : number = 0;
  public yearWanted : number = 0;

  get currentMonth(): BilanEco {
    return this._currentMonth
  };
  set currentMonth(currentMonth: BilanEco) {
    this._currentMonth = currentMonth;
  }

  constructor(private bookService: BookService) {}


  public UpdateMonthTable(month : number, year : number) {
    this.wantedBilan = [];
    let start = new Date(year, month, 1,0,0,1);
    let end = new Date(year, month, 1,0,0,1);
    month = end.getMonth() + 1;
    if (month <= 11) {
      end.setMonth(month);
    } 
    else {
      end.setFullYear(end.getFullYear() + 1);
      end.setMonth(0);
    }
    end.setTime(end.getTime() - 24 * 60 * 60 *1000);
    if (this.completeEco != null) {
      this.completeEco.list.forEach(bilan => {
        let d = new Date(bilan.startdate);
        if (start <= d && d <= end) {
          this.wantedBilan.push(bilan);
        }
      });
    }
    this.currentBilanWantedDataSource = new MatTableDataSource(this.wantedBilan);

  }

  public nextMonth() {
    if (this.monthWanted == 11) {
      this.yearWanted++;
      this.monthWanted = 0;
    }
    else {
      this.monthWanted++;
    }
    this.UpdateMonthTable(this.monthWanted, this.yearWanted);
  }

  public previousMonth() {
    if (this.monthWanted == 0) {
      this.yearWanted--;
      this.monthWanted = 11;
    }
    else {
      this.monthWanted--;
    }
    this.UpdateMonthTable(this.monthWanted, this.yearWanted);
  }

  private loadEcoBilan(start: Date, end: Date) {
    this.bookService.getBookeBilanEcoResume(start, end).subscribe(
      response => {
        // console.log(response);
        this._currentMonth = response;
        this.loadCurrenMonth = true;

        // this.currentBilanDataSource.paginator = this.paginator;


        this.currentBilanDataSource = new MatTableDataSource(this._currentMonth.list);

      }, error => {
        // console.error(error);
      }
    );
  }
  applyFilter(filterValue: string) {
    this.currentBilanDataSource.filter = filterValue.trim().toLowerCase();

    if (this.currentBilanDataSource.paginator) {
      this.currentBilanDataSource.paginator.firstPage();
    }
  }

  ngOnInit() {

    // console.log("response");
    let end = new Date();
    end.setTime(end.getTime() - 1000 * 60 * 60 * 2);
    let start = new Date(end.getFullYear(), end.getMonth() - 1, 1, 0, 0, 0, 1);

    // end =  new Date(start.getFullYear(), start.getMonth(), 1, 0,0,0,1);
    //  month = end.getMonth() + 1;
    // if (month <= 11) {
    //   end.setMonth(month);
    // } 
    // else {
    //   end.setFullYear(start.getFullYear() + 1);
    //   end.setMonth(0);
    // }
    // end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
    // start.setTime(start.getTime() - 50 * 24 * 60 * 60 * 1000);

    //    // console.log(start);
    // console.log(end);
    this.loadEcoBilan(start, end);
    this.bookService.getBookeBilanEcoAllResume().subscribe(response => {
      if (response !== null) {
        this.completeEco = response;
        let d = new Date();
        this.monthWanted = d.getMonth();
        this.yearWanted =d.getFullYear();
        this.previousMonth();
        // console.log(this.completeEco);
        this.allLoad = true;
      }
    }, error => {
      // console.error(error);
    });
  }
}
